import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { layout, token } from "@universityofmaryland/web-styles-library";
function createLayoutGrid({
  columns = 2,
  minHeight,
  enableContainerQueries = true
} = {}) {
  let gridStyle = layout.grid.columnsTwo;
  if (columns === 3) gridStyle = layout.grid.columnsThree;
  if (columns === 4) gridStyle = layout.grid.columnsFour;
  const containerQueryStyles = enableContainerQueries ? {
    containerType: "inline-size"
  } : {};
  const minHeightStyles = minHeight ? {
    [`@media (${token.media.queries.tablet.min})`]: {
      minHeight: `${minHeight} !important`
    }
  } : {};
  return new ElementBuilder().styled(gridStyle).withStyles({
    element: {
      [` > *`]: {
        ...containerQueryStyles,
        ...minHeightStyles
      }
    }
  }).build();
}
export {
  createLayoutGrid
};
//# sourceMappingURL=grid.js.map
